<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
	provide() {
		return {
			reload: this.reload,
		}
	},
  data(){
  	return {
			isRouterAlive: true
    }
  },
  methods: {
		reload() {
			this.isRouterAlive = false;
			this.$nextTick(function () {
				this.isRouterAlive = true
			})
		},
  }
}
</script>

<style>
  @import '../static/swiper.css';
  *{
    margin: 0;
    padding: 0;
    font-family: "微软雅黑";
  }
  html, body{
    width: 100%;
    height: 100%;
  }
  html::-webkit-scrollbar {display:none}
  li{
    list-style: none;
  }
  em, i {
    font-style: normal;
  }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue